/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import { Pressable } from 'react-native-web';
// import Rating from 'react-rating';
import { Button, Container } from 'reactstrap';
import { connect } from 'react-redux';

import { IProduct, IProductVariant } from '@ddot/AddToCartCommon/lib/entities';

import Image from 'Components/Image';
import LoadingModal from 'Components/LoadingModal';
// import { StarEmpty, StarFilled } from 'Icons/Icons';
import Utils from 'Lib/Utils';
import NavActions from 'Services/Navigation/Actions';
import { IAddToCartThunkParams } from 'Redux/slices/cart/controllers/addToCart';

import Actions from 'Redux/Actions';
import Selectors from 'Redux/Selectors';
import { RootState } from 'Redux/store';
import { IGoldPrice } from 'Redux/slices/home/Entities';

import { CartBag, CartBagBlue, Unlike } from 'Icons/Icons';
import {
    productImg,
    productPrice,
    productName,
    productContainer,
    // productRating,
    ButtonContainer,
    RemoveWishListButton,
    buttonIcons,
    AddToCartButton,
} from '../Styles/WishListProductStyle';

interface ProductProps {
    product: IProduct;
    loading: boolean;
    goldPrice: IGoldPrice;
    removeFromWishlist(product: IProduct): void;
    addToCart(item: IAddToCartThunkParams): void;
}

const WishListProduct = (props: ProductProps): JSX.Element | null => {
    const { product, loading, removeFromWishlist, goldPrice, addToCart } = props;

    const [selectedVariant, setSelectedVariant] = useState<IProductVariant | undefined>(undefined);

    const { imageFileNames, imageUrl } = product;

    if (!product) return null;

    const {
        id,
        name,
        currency,
        // overallReviewStars,
    } = product;

    const onPress = () => {
        NavActions.navToProductDetails(id);
    };

    const onRemove = () => {
        removeFromWishlist(product);
    };

    const onAddToCart = () => {
        addToCart({ product, selectedVariant, quantity: 1, remarks: '' });
        onPress();
    };

    const getImageFile = () => {
        if (imageFileNames && imageFileNames.length) {
            return imageFileNames[0];
        }
        if (imageUrl && imageUrl.length) {
            return imageUrl[0];
        }
        return '';
    };

    const { minPrice, maxPrice } = Utils.Jemisys.getItemPriceRange(product, goldPrice);

    return (
        <Container fluid css={productContainer}>
            <div style={{ width: '100%', height: '100%', justifyContent: 'space-between' }}>
                <Pressable onPress={onPress}>
                    <Image css={productImg} url={getImageFile()} alt='Product Img' />

                    <p css={productName}>{name}</p>

                    <div css={productPrice}>
                        {maxPrice !== minPrice ? `${minPrice} ${currency} -` : ''}
                        {`${currency} ${maxPrice}`}
                    </div>
                </Pressable>

                <div css={ButtonContainer}>
                    <Button css={AddToCartButton} onClick={onAddToCart}>
                        Add To Cart
                        <CartBag className='cart' />
                        <CartBagBlue className='cartBlue' />
                    </Button>

                    <Button css={RemoveWishListButton} onClick={onRemove}>
                        Remove
                        <Unlike css={buttonIcons} />
                    </Button>
                </div>
            </div>
            {/* <Rating
                css={productRating}
                initialRating={overallReviewStars}
                emptySymbol={<StarEmpty />}
                fullSymbol={<StarFilled />}
                readonly
            /> */}

            <LoadingModal loading={loading} />
        </Container>
    );
};

const mapStateToProps = (state: RootState) => ({
    loading: Selectors.getUserRemoveFromWishlistAttempting(state),
    goldPrice: Selectors.getHomeGoldPrice(state),
});

const mapDispatchToProps = (dispatch: any) => ({
    addToCart: (item: IAddToCartThunkParams) => dispatch(Actions.cartAddToCart(item)),
    removeFromWishlist: (product: IProduct) => dispatch(Actions.userRemoveFromWishlistLocalWeb({ product })),
});

export default connect(mapStateToProps, mapDispatchToProps)(WishListProduct);
